import * as React from 'react';
export function useDebouncedValue<T>(value: T, delay = 300) {
    const [v, setV] = React.useState(value);
    React.useEffect(() => {
        const id = setTimeout(() => setV(value), delay);
        return () => clearTimeout(id);
    }, [value, delay]);
    return v;
}
